export enum RequestErrors {
  Unique_iesniegums = 'Ar šo personas kodu jau ir reģistrēts iesniegums.',
  Persona_nav_atrasta = 'Šis personas kods nav reģistrēts Fizisko personu reģistrā.',
  Persona_ir_mirusi = 'Šis personas kods Fizisko personu reģistrā norādīts mirušai personai.',
  Persona_neatrodas_latvijā = 'Fizisko personu reģistrā šādai personai nav deklarēta dzīvesvieta Latvijā. Apliecību var pieteikt Latvijā dzīvesvietu deklarējuši vecāki. Ja skolēns/students izglītību iegūst ārzemēs, jāpievieno izziņa no skolas un tās tulkojums (nav jābūt notariāli apstiprinātam).',
  Līguma_datu_lauki_obligāti = 'Līguma datu lauki obligāti.',
  Bloķēt_var_tikai_aktīvus_partnerus = 'Bloķēt var tikai aktīvus partnerus.',
}
